import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NavButton({ path, buttonText }) {
  const navigate = useNavigate();
  
  return (
    <button
      type="button"
      onClick={() => navigate(path)}
      className="rounded bg-light-blue py-2 px-3 text-sm text-primary-blue shadow-sm hover:bg-navy-blue hover:text-white capitalize"
    >
      <p>{buttonText}</p>
    </button>
  );
}
